import React, { FunctionComponent } from 'react';
import { ImageDxPointValues, AdvancedImageDiagnosis, isImageDxPointValues } from '../../AdvancedImageDiagnosis';
import { PainEvaluationSetName, PainEvaluationSets } from '../../AdvancedImageDiagnosis/evaluations';
import { DxImagesSetName, DxImagesSets } from '../../AdvancedImageDiagnosis/dxImages';
import { DiagnosisOptionSetName, DiagnosisOptionSets } from '../../ImageDiagnosis';
import { Answers, AdvancedImageDxField, AdvancedImageDxFieldSchema } from '../dynamicFormSchema';
import { DynamicFieldProps } from '../DynamicField';
import { DynamicFieldComponent } from './DynamicFieldComponentBase';

export const AdvancedImageDxFieldComponent: FunctionComponent<DynamicFieldProps> = ({
  field,
  reactHookField,
  onChange
}) => {
  const dp = AdvancedImageDxFieldSchema.parse(field);

  return (
    <AdvancedImageDiagnosis
      label={dp.label}
      name={dp.name}
      values={reactHookField.value}
      onChange={onChange}
      diagnosisImages={DxImagesSets[dp.dxImages as DxImagesSetName]}
      evaluations={PainEvaluationSets[dp.evaluations as PainEvaluationSetName]}
      evaluationOptions={DiagnosisOptionSets[dp.evaluationOptionSet as DiagnosisOptionSetName]}
    />
  );
};

export class DynamicAdvancedImageDxField extends DynamicFieldComponent<AdvancedImageDxField, ImageDxPointValues> {
  Component = AdvancedImageDxFieldComponent;

  constructor(field: AdvancedImageDxField) {
    super(field);
  }

  getAnswer(answers: Answers): ImageDxPointValues {
    const answer = answers[this.field.name];
    if (answer === undefined) {
      return this.getDefaultValue();
    }

    if (isImageDxPointValues(answer)) {
      return answer;
    }

    throw new Error(`Invalid answer for field ${this.field.name}`);
  }

  getDefaultValue(): ImageDxPointValues {
    return {};
  }

  getValueToSubmit(value: ImageDxPointValues): ImageDxPointValues {
    return value;
  }
}
